// ============================================================
//  BEREAN NATION — Firebase Configuration
//  FREE (Spark plan) setup — no credit card required.
//
//  This uses only the parts of Firebase that are 100% free:
//    • Firestore       (prayers, Bible notes/highlights)
//    • Authentication  (anonymous sign-in, no login required)
//    • Hosting         (publishing the site itself)
//
//  Intentionally NOT used (these require the paid Blaze plan):
//    • Cloud Storage    — not needed; we don't store uploaded files
//    • Cloud Functions  — not needed; push notifications are skipped
//    • Cloud Messaging  — not needed; push notifications are skipped
//
//  If you ever want push notifications later, see the bottom of
//  this file for what would need to be added back (requires Blaze).
// ============================================================

import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey:            "AIzaSyD2q1sWOiJUX5nyZ859835fYDf2zpWKUdk",
  authDomain:        "bereannationapp.firebaseapp.com",
  projectId:         "bereannationapp",
  storageBucket:     "bereannationapp.firebasestorage.app",
  messagingSenderId: "783612153822",
  appId:             "1:783612153822:web:480223882f7f8f36b8574f",
  measurementId:     "G-M7N3GGB0VP",
};

// ── Initialise ────────────────────────────────────────────
const app   = initializeApp(firebaseConfig);
export const db   = getFirestore(app);
export const auth = getAuth(app);

// Offline persistence (works in PWA / Android / iOS web-view)
enableIndexedDbPersistence(db).catch(err => {
  if (err.code === 'failed-precondition') {
    console.warn('Firestore persistence: multiple tabs open');
  } else if (err.code === 'unimplemented') {
    console.warn('Firestore persistence not supported in this browser');
  }
});

// ── Anonymous Auth ────────────────────────────────────────
export async function ensureAuth() {
  return new Promise((resolve) => {
    onAuthStateChanged(auth, user => {
      if (user) {
        resolve(user);
      } else {
        signInAnonymously(auth).then(cred => resolve(cred.user));
      }
    });
  });
}

// ── Analytics ─────────────────────────────────────────────
export const analytics = getAnalytics(app);
